import Config from "src/Constants/Config";
import Skips from "../Skips";
import "./index.sass";

interface BottomTVProps {
  backPageId?: number;
  nextPageId?: number;
  showSkips?: boolean;
  showLogo?: boolean;
}

const BottomTV = ({ backPageId, nextPageId, showSkips = false, showLogo = true }: BottomTVProps) => {
  return (
    <div id="bottom-tv">
      {showLogo ? <img className="bottom-tv-logo" src={`${Config.BASE_URL}/images/provider/Isolation_Mode.png`} alt="" /> : <div></div>}
      {showSkips && backPageId && nextPageId ? <Skips backPageId={backPageId} nextPageId={nextPageId} /> : <div></div>}
    </div>
  );
};

export default BottomTV;
